<template>
    <div>
        <v-tabs
            v-model="active_tab"
            slider-color="white"
            style="padding: 10px"
        >
            <v-tabs-slider color="#2196F3"></v-tabs-slider>
            <v-tab v-for="tab of tabs" :key="tab.id" @click="selectTab(tab.id)">
                {{ tab.name }}
            </v-tab>
        </v-tabs>

        <template v-if="active_tab == 0 && roleGroup != 3">
            <c-search-form
                :rows-per-page-items="[10, 20, 50]"
                :form-name="formName"
                :fields="fields"
                key-property="import_request_id"
                search-url="/importRequest/search?sortField=status,importRequestId&"
                create-url="/importRequest/save"
                delete-url="/importRequest/delete"
                form-type="intable"
                @createNew="openCreateDialog"
                ref="tableData"
                :deleteMulti="false"
                :acceptView="true"
                :acceptEdit="false"
                :acceptDelete="false"
                :acceptCreate="roleGroup == 1"
                :customCreateNew="true"
                @viewItem="viewItem"
                @setLastSearchValues="setLastSearchValues"
                :lastSearchValues="lastSearchValues"
                orderBy="asc,desc"
            />
        </template>
        <template v-else-if="active_tab == 1 || active_tab == 0 && roleGroup == 3">
            <c-search-form
                :rows-per-page-items="[10, 20, 50]"
                :form-name="formName3"
                :fields="importWhFields"
                key-property="import_id"
                search-url="/importWh/search?sortField=status,importDate&"
                form-type="intable"
                ref="tableData"
                :deleteMulti="false"
                :acceptView="true"
                :acceptEdit="false"
                :acceptDelete="false"
                :customCreateNew="false"
                :acceptCreate="false"
                @viewItem="viewImportWh"
                @setLastSearchValues="setLastSearchValues"
                :lastSearchValues="lastSearchValues"
                orderBy="asc,desc"
            />
        </template>
        
        <modal-order-request
            :areas="areas"
            :dialog="dialog"
            @close="close"
            @selectRequest="selectRequest"
        />

        <v-dialog max-width="900px" :v-model="false" persistent>
            <v-card>
                <v-toolbar color="primary" dark>
                    <v-toolbar-title style="padding-left: 0px">
                        Chọn đề nghị mua
                    </v-toolbar-title>
                </v-toolbar>
                <v-btn
                    @click="close"
                    icon
                    style="
                        position: absolute;
                        right: 10px;
                        top: 10px;
                        color: #fff;
                    "
                >
                    <v-icon>cancel</v-icon>
                </v-btn>
                <v-card-text>
                    <!-- <v-layout wrap>
                        <v-flex xs12>
                            <v-select
                                :items="lstRequestOrder"
                                :label="$t('Số đề nghị')"
                                v-model="itemCreate.reqOrdId"
                                item-value="reqOrdId"
                                item-text="requestNumber"
                            />
                        </v-flex>
                    </v-layout> -->
                    <!-- <v-layout> -->
                        <!-- <v-flex> -->
                            <table class="lstTable">
                                <tr>
                                    <th width="20%">Số đề nghị</th>
                                    <th width="20%">Ngày đề nghị</th>
                                    <th width="20%">Khu nuôi</th>
                                    <th width="20%">Trạng thái</th>
                                    <th width="20%"></th>
                                </tr>
                                <template v-for="(item, index) in lstRequestOrder">
                                    <tr :key="index">
                                        <td style="text-align: center;">{{ item.requestNumber }}</td>
                                        <td style="text-align: center;">{{ dateFormat(item.requestDate) }}</td>
                                        <td style="text-align: center;">
                                            <template v-for="(a, i) in areas">
                                                <span v-if="a.categoryId == item.areaId" :key="i">
                                                    {{ a.categoryName }}
                                                </span>
                                            </template>
                                        </td>
                                        <td style="text-align: center;">
                                            <template v-for="(s, i) in requestOrderStatus">
                                                <p v-if="s.value == item.status" :key="i">
                                                    {{ s.text }}
                                                </p>
                                            </template>
                                            <div v-if="item.incomplete == 1">
                                                (Thiếu vật tư)
                                            </div>
                                            <div v-if="item.incomplete == 2">
                                                (Thừa vật tư)
                                            </div>
                                        </td>
                                        <td style="text-align: center;">
                                            <v-btn color="primary" @click="save(item.reqOrdId)">
                                                Tạo thông báo
                                            </v-btn>
                                        </td>
                                    </tr>
                                </template>
                            </table>
                        <!-- </v-flex> -->
                    <!-- </v-layout> -->
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <!-- <v-btn color="primary" @click="save">
                        <v-icon dark left>save</v-icon>
                        {{ $t("Tạo thông báo") }}
                    </v-btn> -->
                    <v-btn color="error" @click="close">
                        <v-icon dark left>cancel</v-icon>
                        {{ $t("lang.common.cancel") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import axios from "axios";
import moment from "moment";
import { requestConstants, roleConstants } from "@/constants";
import ModalOrderRequest from "./component/ModalOrderRequest.vue";

export default {
    name: "request_import",
    components: { CSearchForm, ModalOrderRequest },
    data: () => {
        return {
            formName: "Danh sách thông báo giao hàng",
            formName3: "Danh sách phiếu nhập kho",
            roleGroup: 0,
            dialog: false,
            areas: [],
            warehouses: [],
            lstRequestOrder: [],
            requestOrderStatus: [],
            lastSearchValues: {},
            itemCreate: {
                reqOrdId: '',
                requestOrderNumber: '',
            },
            active_tab: 0,
            tabs: [
                {id: 1, name: 'Thông báo giao hàng'},
                {id: 2, name: 'Phiếu nhập kho'},
            ],
            searchUrl: "",
            fields: [
                {
                    value: "index",
                    text: "lang.common.index",
                    sortable: false,
                    headerStyle: "text-align:center",
                },
                // {
                //     value: "warehouseId",
                //     text: "Mã kho",
                //     search: true,
                //     headerStyle: "text-align:center",
                //     type: "select",
                //     name: "warehouseId",
                //     items: [],
                //     itemText: "categoryCode",
                //     itemValue: "categoryId",
                // },
                {
                    value: "requestNumber",
                    text: "Số thông báo",
                    search: true,
                    headerStyle: "text-align:center",
                    renderItem: (item) => {
                        let text = item.requestNumber;
                        if (item.content != undefined && item.content.length > 0) {
                            text += " - " + item.content;
                        }
                        return text;
                    },
                },
                {
                    value: "requestOrderNumber",
                    text: "Số đề nghị",
                    search: true,
                    headerStyle: "text-align:center",
                },
                {
                    value: "requestDate",
                    text: "Ngày thông báo",
                    headerStyle: "text-align:center",
                    dateFormat: "dd/MM/yyyy",
                    search: true,
                    type: "datepicker"
                },
                {
                    value: "areaId",
                    text: "Khu nuôi",
                    search: true,
                    headerStyle: "text-align:center",
                    type: "select",
                    name: "areaId",
                    items: [],
                    itemText: "categoryName",
                    itemValue: "categoryId",
                },
                {
                    value: "status",
                    text: "lang.user.status",
                    search: true,
                    headerStyle: "text-align:center",
                    type: "select",
                    name: "status",
                    items: requestConstants.requestImportStatus,
                    itemText: "text",
                    itemValue: "value",
                },
                {
                    value: "action",
                    width: "5%",
                    text: "lang.common.actions",
                    compound: true,
                    headerStyle: "text-align:center",
                },
            ],
            importWhFields: [
                {
                    value: "index",
                    text: "lang.common.index",
                    sortable: false,
                    headerStyle: "text-align:center",
                },
                {
                    value: "importNumber",
                    text: "Số PNK",
                    search: true,
                    headerStyle: "text-align:center",
                },
                {
                    value: "importRequestNumber",
                    text: "Số thông báo",
                    search: true,
                    headerStyle: "text-align:center",
                },
                {
                    value: "importDate",
                    text: "Ngày nhập kho",
                    headerStyle: "text-align:center",
                    dateFormat: "dd/MM/yyyy",
                    search: true,
                    type: "datepicker"
                },
                {
                    value: "areaId",
                    text: "Khu nuôi",
                    search: true,
                    headerStyle: "text-align:center",
                    type: "select",
                    name: "areaId",
                    items: [],
                    itemText: "categoryName",
                    itemValue: "categoryId",
                },
                {
                    value: "supplyId",
                    text: "Nhà cung cấp",
                    search: true,
                    headerStyle: "text-align:center",
                    type: "select",
                    name: "supplyId",
                    items: [],
                    itemText: "partnerName",
                    itemValue: "partnerId",
                },
                {
                    value: "status",
                    text: "lang.user.status",
                    search: true,
                    headerStyle: "text-align:center",
                    type: "select",
                    name: "status",
                    items: [],
                    itemText: "text",
                    itemValue: "value",
                },
                {
                    value: "action",
                    width: "5%",
                    text: "lang.common.actions",
                    compound: true,
                    headerStyle: "text-align:center",
                },
            ],
        };
    },

    created() {
        let queryParam = this.$route.query;

        // console.log(this.$store.state.auth.user);
        // 2: thủ kho;  26: mua hàng
        const role = parseInt(this.$store.state.auth.user.role);
        console.log(role);
        if (role == 26 || role == 3) {
            this.roleGroup = 1;
        } else if (role == 2) {
            this.roleGroup = 2;
        } else if (role == 4) {
            this.roleGroup = 3;
        }

        if (role == 4) {
            this.tabs = [
                {id: 1, name: 'Phiếu nhập kho'}
            ];
        }

        let activeTab = queryParam.activeTab;
        if(activeTab != undefined){
            this.active_tab = activeTab -1;
        }
        
        let searchImportRequest = queryParam.searchImportRequest;
        if(searchImportRequest !=undefined){
          try{
            this.lastSearchValues = JSON.parse(searchImportRequest);
          } catch (e){

          }
        }
        this.requestOrderStatus = requestConstants.requestStatus["ALL"];

        // khu nuôi
        this.getPondArea();
        this.getWarehouse();
        this.setImportWhStatus();
        this.getSupplier();
        // đề nghị mua hàng
        // this.getRequestOrder(4);
        // this.getRequestOrder(5);
    },

    methods: {
        setLastSearchValues: function (values) {
            this.lastSearchValues = Object.assign(this.lastSearchValues, values);
        },
        createParamLastSearch: function (values) {
            const obj1 = {
                searchImportRequest: JSON.stringify(values),
            };
            const obj2 = this.$route.query;
            return {...obj1, ...obj2};
        },
        openCreateDialog: function () {
            this.dialog = true;
        },
        viewItem: function (item) {
            this.$router.push({ path: '/importRequest/view/' + item.importRequestId, query: this.createParamLastSearch(this.lastSearchValues)  });
        },
        viewImportWh: function (item) {
            if (item.importRequestId != null && item.importRequestId > 0) {
                this.$router.push({ path: '/importRequest/importWhView/' + item.importRequestId, query: this.createParamLastSearch(this.lastSearchValues)  });
            } else {
                this.$route.query.searchByImportWhId = 1;
                this.$router.push({ path: '/importRequest/importWhView/' + item.importId, query: this.createParamLastSearch(this.lastSearchValues)  });
            }
        },
        close() {
            this.dialog = false;
        },
        save(reqOrdId) {
            this.dialog = false;
            this.$router.push({ path: '/importRequest/create/' + reqOrdId });
        },
        selectRequest(reqOrdId) {
            this.dialog = false;
            this.$router.push({ path: '/importRequest/create/' + reqOrdId });
        },
        getRequestOrder(status = 4) {
            axios.post(
                process.env.VUE_APP_API_URL + "/requestOrder/searchAll?pageSize=50&page=1&orderBy=desc&sortField=requestDate", {
                    status: status
                }
            ).then(
                (data) => {
                    if (data.items) {
                        this.lstRequestOrder = [...this.lstRequestOrder, ...data.items];
                        // console.log(this.lstRequestOrder);
                    }
                }
            );
        },
        getPondArea() {
            axios.post(
                process.env.VUE_APP_API_URL +
                    //"/category/listByType?type=PONDAREA"
                  "/category/myArea"
            )
            .then((data) => {
                if (data.length > 0) {
                    this.areas = data;
                    // importRequest
                    let itemFields = this.fields.filter(function (e) {
                        return e.name == "areaId";
                    });
                    if (itemFields != undefined && itemFields.length > 0) {
                        itemFields[0].items = data;
                    }

                    // importWh
                    let itemFieldWh = this.importWhFields.filter(function (e) {
                        return e.name == "areaId";
                    });
                    if (itemFieldWh != undefined && itemFieldWh.length > 0) {
                        itemFieldWh[0].items = data;
                    }
                }
            });
        },
        getWarehouse() {
            axios.post(
                process.env.VUE_APP_API_URL +
                    "/category/listByType?type=WAREHOUSE"
            )
            .then((data) => {
                if (data.length > 0) {
                    this.warehouses = data;
                    let itemFields = this.fields.filter(function (e) {
                        return e.name == "warehouseId";
                    });
                    if (itemFields != undefined && itemFields.length > 0) {
                        itemFields[0].items = data;
                    }
                }
            });
        },
        dateFormat(date) {
            return moment(String(date)).format('DD-MM-YYYY');
        },
        selectTab(id) {
            this.$router.push({query: {activeTab: id}})
        },
        setImportWhStatus() {
            let status = requestConstants.importWhStatus;
            if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR) {
                status = status.filter(function (e) {
                    return e.value >= 2;
                });
            }

            // this.requestStatus = status;
            let itemFields = this.importWhFields.filter(function (e) {
                return e.name == "status";
            });
            if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = status;
            }
        },
        getSupplier() {
            axios.post(
                process.env.VUE_APP_API_URL + "/partner/search?pageSize=-1&page=-1&orderBy=asc",
                 {typeId: 340}
            )
                .then(
                    (data) => {
                        if (data.items) {
                            this.supplys = data.items;
                            let itemFields = this.importWhFields.filter(function (e) {
                                return e.name == "supplyId";
                            });
                            if (itemFields != undefined && itemFields.length > 0) {
                                itemFields[0].items = data.items;
                            }
                        }
                    }
                );
        },
    },
    destroyed() {},
};
</script>
